import { IJsonQuery } from 'shared/json_query';

export const isDeveloperPage = (jsonQuery: IJsonQuery): boolean =>
  !!jsonQuery.geo && jsonQuery.geo.value.length === 1 && jsonQuery.geo.value[0].type === 'builder';
